export enum Exploitation {
  PLANNING = 'planning',
  MAKING = 'making',
  VIEWING = 'viewing',
  SHARING = 'sharing',
  CREATING = 'creating',
}

export enum Lewd {
  ACTS = 'acts',
  NUDE = 'nude',
  VISIBLE = 'visible',
}

export enum Abuse {
  ABUSE = 'abuse',
  COMMENTS = 'comments',
  TOWARD = 'toward',
}

export enum OtherComments {
  APPEARANCE = 'appearance',
  AGE = 'age',
  DISABILITY = 'disability',
  ETHNICITY = 'ethnicity',
  GENDER = 'gender',
  RACE = 'race',
  RELIGION = 'religion',
  ORIENTATION = 'orientation',
}
